import React from 'react';
import PropTypes from 'prop-types';

const Badge = ({
  variant = 'accent',
  size = 'md',
  children,
  className = '',
}) => {
  const baseStyles = `
    inline-flex items-center justify-center
    font-semibold rounded-full
    transition-all duration-slow ease-in-out
  `;

  const variantStyles = {
    success: 'bg-light-semantic-successBg dark:bg-brand-success dark:bg-opacity-20 text-light-semantic-success dark:text-brand-success border border-light-semantic-success dark:border-brand-success',
    warning: 'bg-light-semantic-warningBg dark:bg-brand-warning dark:bg-opacity-20 text-light-semantic-warning dark:text-brand-warning border border-light-semantic-warning dark:border-brand-warning',
    error: 'bg-light-semantic-errorBg dark:bg-brand-error dark:bg-opacity-20 text-light-semantic-error dark:text-brand-error border border-light-semantic-error dark:border-brand-error',
    info: 'bg-light-semantic-infoBg dark:bg-brand-info dark:bg-opacity-20 text-light-semantic-info dark:text-brand-info border border-light-semantic-info dark:border-brand-info',
    accent: 'bg-light-accent-red dark:bg-brand-accent-red text-white dark:text-white',
  };

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'accent']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Badge;
